<template>
  <div class="console-layout">
    <app-header :showDoc="true" tabs="backstage"></app-header>
    <div
      class="app-wrapper admin-shell"
      :class="classObj"
      v-if="
        enterpriseInfo && enterpriseInfo.eid && userAuthLists && permissions
      "
    >
      <sidebar class="sidebar-container"></sidebar>
      <div class="main-container">
        <navbar></navbar>
        <app-main></app-main>
      </div>
    </div>
    <template v-else v-loading="true"></template>
    <div
      class="app-wrapper admin-shell admin-shell--empty"
      v-if="enterpriseInfo && enterpriseInfo.eid && !permissions"
    >
      <no-permissions />
    </div>
  </div>
</template>

<script>
import { Sidebar, AppMain, Navbar } from './components';
import ResizeMixin from './mixin/ResizeHandler';
export default {
  name: 'Layout',
  components: {
    sidebar: Sidebar,
    Navbar,
    'app-main': AppMain
  },
  mixins: [ResizeMixin],
  created() {
    this.GetUserInfo();
  },

  data() {
    return {
      permissions: true,
      userInfo: null
    };
  },

  computed: {
    sidebar() {
      return this.$store.state.app.sidebar;
    },
    device() {
      return this.$store.state.app.device;
    },
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === 'mobile'
      };
    },
    enterpriseInfo() {
      return this.$store.state.enterprise.enterpriseInfo;
    },
    userAuthLists() {
      return this.$store.state.user.userAuths;
    }
  },
  methods: {
    GetUserInfo() {
      this.$store
        .dispatch('GetUserInfo')
        .then((res) => {
          if (res && res.eid) {
            this.userInfo = res;
            this.GetUserAuths();
            this.GetCurrnetEnterpriseInfo(res.eid);
            this.GetCurrnetOrgList();
            if (res.roles.indexOf('企业管理员') != -1 || res.roles.indexOf('应用管理员') != -1) {
              window.sessionStorage.setItem('isAdmin', true);
            } else {
              if (res.roles.indexOf('普通用户') != -1) {
                window.sessionStorage.setItem('isAdmin', false);
              } else if (res.roles.indexOf('分享用户角色') != -1) {
                window.sessionStorage.setItem('isAdmin', false);
              } else {
                window.sessionStorage.setItem('isAdmin', true);
              }
            }
          } else {
            this.FedLogOut();
          }
        })
        .catch(() => {
          this.FedLogOut();
        });
    },
    GetUserAuths() {
      this.$store
        .dispatch('GetUserAuthList')
        .then((res) => {
          this.permissions = res && Array.isArray(res.permissions);
        })
        .catch(() => {
          this.FedLogOut();
        });
    },
    GetCurrnetEnterpriseInfo(eid) {
      this.$store
        .dispatch('GetEnterpriseInfo', eid)
        .then((en) => {
          if (en && en.openMarket) {
            this.$store
              .dispatch('GetMarketDetail', { marketID: en.marketID })
              .then(() => {});
          }
          return null;
        })
        .catch(() => {
          this.FedLogOut();
        });
    },
    GetCurrnetOrgList(eid) {
      this.$store
        .dispatch('GetUserOrgList', eid)
        .then(() => {
          return null;
        })
        .catch(() => {
          this.FedLogOut();
        });
    },
    FedLogOut() {
      this.$store.dispatch('FedLogOut').then(() => {
        this.$router.push({
          name: 'login',
          query: { redirect: this.$route.fullPath }
        });
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/layout/Layout.vue